import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Keep a half-filled form as a local draft (brief §3). Persists `state` to
 * localStorage under `lux_draft:{key}` on every change; `clear()` once the
 * form is submitted. Files can't be persisted — callers keep text fields only.
 */
export function useFormDraft(key, initial) {
  const storageKey = `lux_draft:${key}`;
  const [state, setState] = useState(() => {
    try {
      const raw = localStorage.getItem(storageKey);
      if (raw) return { ...initial, ...JSON.parse(raw).data, __restored: true };
    } catch { /* ignore */ } // eslint-disable-line no-empty
    return initial;
  });
  const restored = useRef(!!state.__restored);
  useEffect(() => {
    const { __restored, ...data } = state;
    try { localStorage.setItem(storageKey, JSON.stringify({ data, saved_at: Date.now() })); } catch { /* ignore */ } // eslint-disable-line no-empty
  }, [state, storageKey]);
  const clear = useCallback(() => {
    try { localStorage.removeItem(storageKey); } catch { /* ignore */ } // eslint-disable-line no-empty
    setState({ ...initial });
  }, [storageKey]); // eslint-disable-line react-hooks/exhaustive-deps
  return [state, setState, clear, restored.current];
}
